$(document).ready(function() {

	// Überschrift bei den Wetter-Texten tauschen
	$('.ttgMowisTabLink').click(function(){
		var text = $(this).attr('data-headline');
		$('.ttgMowisWetterHeadline').html(text);
	});

	// Aktives Akkordion einfärben
	$('.ttgWetterAccordion').on('show.bs.collapse', function () {
         $(this).addClass('ttgWetterAccordionActive');
    });

    $('.ttgWetterAccordion').on('hide.bs.collapse', function () {
         $(this).removeClass('ttgWetterAccordionActive');
    });
});